module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mx-2"
  }, [_c('div', {
    staticClass: "grid grid-cols-2 gap-x-5"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex mt-1 items-center"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password.old_password),
      expression: "password.old_password"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300",
    attrs: {
      "type": "password",
      "placeholder": "Insert your current password"
    },
    domProps: {
      "value": (_vm.password.old_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.password, "old_password", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-5"
  }, [_c('div', {
    staticClass: "sm:mr-2.5 mr-5 w-full"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password.new_password),
      expression: "password.new_password"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300",
    attrs: {
      "placeholder": "Insert your new password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password.new_password)
    },
    on: {
      "keyup": function($event) {
        _vm.password.error = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.password, "new_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('PasswordStrength', {
    attrs: {
      "toggle": true,
      "badge": false,
      "strength-meter-only": true
    },
    model: {
      value: (_vm.password.new_password),
      callback: function($$v) {
        _vm.$set(_vm.password, "new_password", $$v)
      },
      expression: "password.new_password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-xs text-gray-400 mt-10"
  }, [_vm._v("Use 8 ore more characters with a mix of letters, numbers & symbols.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sm:mr-2.5 md: mr-5 w-full"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "flex mt-1 items-center"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password.new_password_validation),
      expression: "password.new_password_validation"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300",
    attrs: {
      "type": "password",
      "placeholder": 'Confirm New Password'
    },
    domProps: {
      "value": (_vm.password.new_password_validation)
    },
    on: {
      "keyup": function($event) {
        _vm.password.error = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.password, "new_password_validation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-xs text-red-500 italic"
  }, [_vm._v("\n            " + _vm._s(_vm.password.error) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "my-6"
  }, [_c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": _vm.disabledButton
    },
    on: {
      "click": function($event) {
        return _vm.changePassword()
      }
    }
  }, [_vm._v("\n      Update Password\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "font-medium text-gray-700"
  }, [_vm._v("Current Password "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "font-medium text-gray-700"
  }, [_vm._v("New Password "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "font-medium text-gray-700"
  }, [_vm._v("Confirm New Password "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-d2caa414!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/profile/profileTabs/passwordTab.vue
// module id = 1612
// module chunks = 61